export default {
  title: '{{company}} har opdateret dit afhentningstidspunkt',
  new_time_label: 'Nyt tidspunkt',
};
